import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectServiceIds,
  selectActiveServiceId,
  selectPublishTermsStatus,
  selectActiveServiceIndex,
} from '../../../../../../selectors/publishTerms';
import {
  selectAnalyticsDiffPricingIds,
  selectAnalyticsFormId,
  selectAnalyticsOfferStatus,
  selectAnalyticsProduct,
} from '../../../../../../selectors/analytics';
import { EPublishTermsStatus } from '../../../../../../redux/reducers';
import { selectCurrentBet } from '../../../../../../selectors/auction';
import { selectBetPosition, selectIsBetPositionVisible } from '../../../../../../selectors/betPosition';
import { useIsMobileDevice } from '../../../../../../hooks';
import { ElementInViewport } from '../../../../../common/ElementInViewport';

import { ServicesSlider } from './components/ServicesSlider';
import { ServiceContainer } from './components/Service';
import { trackDiffPricingShow, trackServicesShow, trackSliderScroll } from './tracking';

export const ServicesContainer = () => {
  const serviceIds = useSelector(selectServiceIds);
  const status = useSelector(selectPublishTermsStatus);
  const activeServiceIndex = useSelector(selectActiveServiceIndex);
  const isBetPositionVisible = useSelector(selectIsBetPositionVisible);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const activeServiceId = useSelector(selectActiveServiceId)!;
  const bet = useSelector(selectCurrentBet);
  const { offerPosition = null, page = null } = useSelector(selectBetPosition) || {};
  const analyticsFormId = useSelector(selectAnalyticsFormId);
  const diffPricingIds = useSelector(selectAnalyticsDiffPricingIds);

  const isMobile = useIsMobileDevice();

  const handleServicesVisible = React.useCallback(() => {
    trackServicesShow({
      analyticsOfferStatus,
      analyticsProduct,
      serviceIds,
      activeServiceId,
      bet,
      offerPosition,
      page,
      analyticsFormId,
    });

    if (diffPricingIds) {
      const { diffPriceIterationId, diffPriceGranuleGuid } = diffPricingIds;

      trackDiffPricingShow({ analyticsOfferStatus, analyticsFormId, diffPriceIterationId, diffPriceGranuleGuid });
    }
  }, [analyticsProduct, serviceIds, activeServiceId, bet, offerPosition, page, diffPricingIds]);

  const handleScrollSliderRight = React.useCallback(() => {
    trackSliderScroll({ analyticsOfferStatus, analyticsProduct, analyticsFormId, direction: 'right' });
  }, [analyticsProduct, analyticsFormId]);

  const handleScrollSliderLeft = React.useCallback(() => {
    trackSliderScroll({ analyticsOfferStatus, analyticsProduct, analyticsFormId, direction: 'left' });
  }, [analyticsProduct, analyticsFormId]);

  return status === EPublishTermsStatus.success ? (
    <ElementInViewport threshold={0.25} onVisible={handleServicesVisible}>
      <ServicesSlider
        isMobile={isMobile}
        isBetPositionVisible={isBetPositionVisible}
        activeServiceIndex={activeServiceIndex}
        onScrollSliderRight={handleScrollSliderRight}
        onScrollSliderLeft={handleScrollSliderLeft}
      >
        {serviceIds.map(serviceId => (
          <ServiceContainer key={serviceId} serviceId={serviceId} />
        ))}
      </ServicesSlider>
    </ElementInViewport>
  ) : null;
};
